import React, {useContext} from "react";
import {useHistory} from "react-router-dom";
import classnames from "classnames";

// reactstrap components

import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Label, CardHeader,CardBody,Button
} from "reactstrap";

import {Col, FormControl, FormGroup, Row, } from "react-bootstrap";
import { RegistrationContext } from "../../../context/RegistrationContext";

// Import the stripe react components
//import {CardElement, StripeProvider, Elements} from "react-stripe-elements";
//import '../../../Utils/CCstyles.css';
//import 'react-credit-cards/es/styles-compiled.css';
//import SupportedCards from '../../../Utils/CCCards';
import Card from 'react-credit-cards-2';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
} from '../../../utils/utils';

import 'react-credit-cards-2/dist/lib/styles.scss';
import Payment from "payment";
import SweetAlert from "react-bootstrap-sweetalert";
import rest from "../../../API/api";
import PropTypes from "prop-types";

const Step3 = React.forwardRef((props, ref) => {
    const [step3Select, setstep3Select] = React.useState(null);
    const [registrationState, setRegistrationState] = useContext(RegistrationContext);
    const [numberError, setnumberError] = React.useState(null);
    const [nameError, setnameError] = React.useState(null);
    const [expiryError, setexpiryError] = React.useState(null);
    const [cvcError, setcvcError] = React.useState(null);
    const [zipError, setzipError] = React.useState(null);
    const [agreeError, setagreeError] = React.useState(null);
    const [issuerrError, setissuerError] = React.useState(null);
    const [focusedError, setfocusedError] = React.useState(null);
    const [formDataError, setformDataError] = React.useState(null);
    const [sentEmailr, setsentEmail] = React.useState(false);
    const [agree, setagree] = React.useState(false);
    const [focused, setfocused] = React.useState("");
    const [alert, setalert] = React.useState(null);

    // Local state for inputs to prevent re-render freezing
    const [localCCNumber, setLocalCCNumber] = React.useState("");
    const [localCCName, setLocalCCName] = React.useState("");
    const [localCCExpiry, setLocalCCExpiry] = React.useState("");
    const [localCCCvc, setLocalCCCvc] = React.useState("");
    const [localCCZip, setLocalCCZip] = React.useState("");

    const history = useHistory();

    // Initialize local state from context on mount
    React.useEffect(() => {
        if (registrationState.CCNumber) setLocalCCNumber(registrationState.CCNumber);
        if (registrationState.CCName) setLocalCCName(registrationState.CCName);
        if (registrationState.CCExpiry) setLocalCCExpiry(registrationState.CCExpiry);
        if (registrationState.CCCvc) setLocalCCCvc(registrationState.CCCvc);
        if (registrationState.CCZip) setLocalCCZip(registrationState.CCZip);
    }, []);

    // Sync local state back to context when component unmounts (Previous button)
    React.useEffect(() => {
        return () => {
            setRegistrationState(prevState => ({
                ...prevState,
                CCNumber: localCCNumber,
                CCName: localCCName,
                CCExpiry: localCCExpiry,
                CCCvc: localCCCvc,
                CCZip: localCCZip
            }));
        };
    }, [localCCNumber, localCCName, localCCExpiry, localCCCvc, localCCZip, setRegistrationState]);

    const handleCallback = ({issuer}, isValid) => {
        if (isValid) {
            // Only update if issuer actually changed to prevent unnecessary re-renders
            setRegistrationState(prevState => {
                if (prevState.CCIssuer !== issuer) {
                    return {...prevState, CCIssuer: issuer};
                }
                return prevState;
            });
        }
    };

    const handleInputFocus = ({target}) => {
        setfocused(target.name);
    };

    // Format CC number with spaces for display
    const formatCCNumber = (value) => {
        if (!value) return '';

        // Detect card type
        const issuer = Payment.fns.cardType(value);

        let formatted = '';
        let spacePositions = [];

        // Define space positions based on card type
        if (issuer === 'amex') {
            // American Express: 4-6-5 format (e.g., 3782 822463 10005)
            spacePositions = [4, 10]; // Space after 4th and 10th digit
        } else if (issuer === 'dinersclub') {
            // Diners Club: 4-6-4 format (e.g., 3056 930902 5904)
            spacePositions = [4, 10]; // Space after 4th and 10th digit
        } else {
            // Visa, Mastercard, Discover, JCB, UnionPay: 4-4-4-4 format
            // Maestro: 4-4-4-4 format
            spacePositions = [4, 8, 12]; // Space after 4th, 8th, and 12th digit
        }

        // Insert spaces at the appropriate positions
        for (let i = 0; i < value.length; i++) {
            formatted += value[i];
            if (spacePositions.includes(i + 1) && i < value.length - 1) {
                formatted += ' ';
            }
        }

        return formatted;
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;

        if (name === 'number') {
            // Remove all non-digits (including spaces from previous formatting)
            const digitsOnly = value.replace(/\D/g, '');
            // Limit to 16 digits
            if (digitsOnly.length <= 16) {
                setLocalCCNumber(digitsOnly);
            }
        } else if (name === 'expiry') {
            // Remove all non-digits
            const digitsOnly = value.replace(/\D/g, '');
            // Limit to 4 characters (MMYY)
            if (digitsOnly.length <= 4) {
                // Format as MM/YY for display
                let formattedValue = digitsOnly;
                if (digitsOnly.length >= 3) {
                    formattedValue = `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
                }
                setLocalCCExpiry(formattedValue);
            }
            //Have to use target name of cvc and not CCCvc because the card flip is looking for this to be the name of focused element
        } else if (name === 'cvc') {
            // Remove all non-digits
            const digitsOnly = value.replace(/\D/g, '');
            // Limit to 4 characters
            if (digitsOnly.length <= 4) {
                setLocalCCCvc(digitsOnly);
            }
        } else if (name === 'name') {
            setLocalCCName(value);
        } else if (name === 'zip') {
            // Remove all non-digits
            const digitsOnly = value.replace(/\D/g, '');
            // Limit to 5 characters
            if (digitsOnly.length <= 5) {
                setLocalCCZip(digitsOnly);
            }
        }
    };

    // Sync local state to context state for validation and card display
    const syncToContext = () => {
        setRegistrationState(prevState => {
            // Only update if values have actually changed
            if (prevState.CCNumber !== localCCNumber ||
                prevState.CCName !== localCCName ||
                prevState.CCExpiry !== localCCExpiry ||
                prevState.CCCvc !== localCCCvc ||
                prevState.CCZip !== localCCZip) {
                return {
                    ...prevState,
                    CCNumber: localCCNumber,
                    CCName: localCCName,
                    CCExpiry: localCCExpiry,
                    CCCvc: localCCCvc,
                    CCZip: localCCZip
                };
            }
            return prevState;
        });
    };

    /*
    const handleSubmit = e => {
      e.preventDefault();
      const { issuer } = this.state;
      const formData = [...e.target.elements]
          .filter(d => d.name)
          .reduce((acc, d) => {
              acc[d.name] = d.value;
              return acc;
          }, {});

      this.setState({ formData });
      this.form.reset();
    };
  */
    const isValidated = () => {
        let isValid = true;

        // Regex patterns
        const regex_zipcode = /^\d{5}$/;
        const regex_expiry = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

        // Determine card type and required length
        const issuer = Payment.fns.cardType(localCCNumber);
        let regex_cardnumber, cardnumberlength, cvcLength;

        switch (issuer) {
            case "amex":
                regex_cardnumber = /^\d{15}$/;
                cardnumberlength = 15;
                cvcLength = 4;
                break;
            case "dinersclub":
                regex_cardnumber = /^\d{14}$/;
                cardnumberlength = 14;
                cvcLength = 3;
                break;
            default:
                regex_cardnumber = /^\d{16}$/;
                cardnumberlength = 16;
                cvcLength = 3;
                break;
        }

        // Validate Credit Card Number
        if (!localCCNumber || localCCNumber.length === 0) {
            setnumberError(
                <small className="text-danger">
                    Credit Card Number is required.
                </small>
            );
            isValid = false;
        } else if (!regex_cardnumber.test(localCCNumber)) {
            setnumberError(
                <small className="text-danger">
                    Please provide a valid {cardnumberlength}-digit Credit Card Number.
                </small>
            );
            isValid = false;
        } else {
            setnumberError(null);
        }

        // Validate Cardholder Name
        if (!localCCName || localCCName.trim().length === 0) {
            setnameError(
                <small className="text-danger">
                    Cardholder Name is required.
                </small>
            );
            isValid = false;
        } else {
            setnameError(null);
        }

        // Validate Expiration Date
        if (!localCCExpiry || localCCExpiry.length === 0) {
            setexpiryError(
                <small className="text-danger">
                    Expiration Date is required.
                </small>
            );
            isValid = false;
        } else if (!regex_expiry.test(localCCExpiry)) {
            setexpiryError(
                <small className="text-danger">
                    Please provide a valid expiration date (MM/YY).
                </small>
            );
            isValid = false;
        } else {
            // Check if card is expired
            const exMonth = parseInt(localCCExpiry.slice(0, 2), 10);
            // Handle both MM/YY and MMYY formats
            const yearPart = localCCExpiry.includes('/')
                ? localCCExpiry.slice(3)
                : localCCExpiry.slice(2);
            const exYear = parseInt("20" + yearPart, 10);

            const today = new Date();
            // Card is valid through the END of the expiry month
            // Set to last day of expiry month at 23:59:59
            const expiryDate = new Date(exYear, exMonth, 0, 23, 59, 59);

            if (expiryDate < today) {
                setexpiryError(
                    <small className="text-danger">
                        This credit card has expired. Please use a valid card.
                    </small>
                );
                isValid = false;
            } else {
                setexpiryError(null);
            }
        }

        // Validate CVC
        if (!localCCCvc || localCCCvc.length === 0) {
            setcvcError(
                <small className="text-danger">
                    Security Code (CVC) is required.
                </small>
            );
            isValid = false;
        } else if (localCCCvc.length !== cvcLength) {
            setcvcError(
                <small className="text-danger">
                    Security Code must be {cvcLength} digits.
                </small>
            );
            isValid = false;
        } else {
            setcvcError(null);
        }

        // Validate Zip Code
        if (!localCCZip || localCCZip.length === 0) {
            setzipError(
                <small className="text-danger">
                    Zip Code is required.
                </small>
            );
            isValid = false;
        } else if (!regex_zipcode.test(localCCZip) || localCCZip.length !== 5) {
            setzipError(
                <small className="text-danger">
                    Please provide a valid 5-digit zip code.
                </small>
            );
            isValid = false;
        } else {
            setzipError(null);
        }

        // Validate Waiver Agreement
        if (!agree) {
            setagreeError(
                <small className="text-danger">
                    You must agree to the Online Waiver and Release form to continue.
                </small>
            );
            isValid = false;
        } else {
            setagreeError(null);
        }

        // If all validations pass, save registration
        if (isValid) {
            setRegistrationState(registrationState => ({...registrationState, sentEmail: false}));
            saveRegistration();
        }

        return isValid;
    };

    const resetRegistrationContext = () => {
        setRegistrationState(registrationState => ({
            ...registrationState,
            EventId: "",
            SignedWaiver: false,
            Name: "",
            Email: "",
            DOB: "",
            Gender: "",
            Phone: "",
            Questions: [],
            CustomerXRef: "",
            Processed: false,
            CCNumber: "",
            CCName: "",
            CCExpiry: "",
            CCCvc: "",
            CCIssuer: "",
            CCZip: "",
            Notes: "",
            focused: "",
            formData: null,
            sentEmail: false,
            EventEnabled: false,
            EventImage: "",
            EventImagePublicId: "",
            EventTitle: "",
            EventSubTitle: "",
            EventDescription: "",
            EventType: "",
            EventContact: "",
            EventPhone: "",
            EventEmail: "",
            EventOtherWebsite: "",
            EventLocation: "",
            EventStartDate: "",
            EventEndDate: "",
            EventAgeRestriction: "",
            EventGenderRestriction: "",
            EventYoungerThan: "",
            EventRequireWaivers: false,
            EventRequireNameEmail: false,
            EventRequireDOB: false,
            EventRequireGender: false,
            EventRequirePhone: false,
            EventIncludeQuestions: false,
            EventIncludedQuestions: [],
            EventRegistrations: [],
            EventAcceptOnlineRegistration: false,
            EventPrice: 0,
            EventMaxRegistrations: 8,
            EventAfterSubmit: "",
            Type: "",
            Event: "",
            EventListDisabled: true,
            eventsList:[]
        }));
    };

    const successAlert = (success) => {

        //Setup the alert and use the context to route to the home page once logged in.
        if (success) {
            if (registrationState.EventAfterSubmit === "Same") {
                setalert(
                    <SweetAlert
                        success
                        title="Thank you for registering!"
                        style={{display: "block"}}

                        onConfirm={() => history.push("/admin/dashboard")}
                        onCancel={() => history.push("/admin/dashboard")}
                        confirmBtnBsStyle="info"
                    >
                        Watch for an email notifying you that your registration is complete!
                    </SweetAlert>
                );
            } else if (registrationState.EventAfterSubmit === "Index") {
                setalert(
                    <SweetAlert
                        success
                        title="Thank you for registering!"
                        style={{display: "block"}}

                        onConfirm={() => history.push("/admin/dashboard")}
                        onCancel={() => history.push("/admin/dashboard")}
                        confirmBtnBsStyle="info"
                    >
                        Watch for an email notifying you that your registration is complete!
                    </SweetAlert>
                );
            }
        }
        else {
                setalert(
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Opps! Something went wrong!"
                        onConfirm={() => setalert(null)}
                        onCancel={() => setalert(null)}
                        confirmBtnBsStyle="danger"
                    >
                        Registration Error, Please contact us directly to verify your registration!
                    </SweetAlert>
                );
            }

    };



    const saveRegistration = async () => {
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log('🎯 Starting Registration Submission');
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

        // Capture local values before resetting context
        const ccDataToSave = {
            EventId: registrationState.EventId,
            SignedWaiver: true,
            Name: registrationState.Name,
            Email: registrationState.Email,
            DOB: registrationState.DOB,
            Gender: registrationState.Gender,
            Phone: registrationState.Phone,
            Processed: false,
            Questions: registrationState.EventIncludedQuestions,
            CustomerXRef: registrationState.CustomerXRef,
            CCNumber: localCCNumber,
            CCName: localCCName,
            CCExpiry: localCCExpiry,
            CCCvc: localCCCvc,
            CCZip: localCCZip,
            CCIssuer: Payment.fns.cardType(localCCNumber),
            Notes: "",
        };

        console.log('📦 Registration Data:', ccDataToSave);
        console.log('🌐 API Endpoint:', rest.register);
        console.log('🔑 API Key:', rest.apiKey);

        resetRegistrationContext();

        try {
            const register = fetch(rest.register, {
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-key': rest.apiKey
                }),
                method: 'POST',
                body: JSON.stringify(ccDataToSave),
            });
            const registerResponse = await register;

            console.log('📡 Response Status:', registerResponse.status);
            console.log('📡 Response OK:', registerResponse.ok);

            const registerResult = await registerResponse.json();
            console.log('✅ Registration Result:', registerResult);
        //console.log("Register Result:");
        //console.log(registerResult);
        //Lets send an email to our admin account for notification that a registration is waiting
        var message = '<html><body>';
        message = message + "<h2> You have a new Registration Request generated from our Website:</h2><br><br>";
        message = message + '<table rules="all" style="border-color: #666;" cellpadding="10">';
        message = message + "<tr style='background: #eee;'><td><strong>" + "New Registration Request" + "</strong> </td><td>" + "Details" + "</td></tr>";
        message = message + "<tr><td><strong>Customer Name:</strong> </td><td>" + ccDataToSave.CCName + "</td></tr>";
        message = message + "<tr><td><strong>Customer Phone Number:</strong> </td><td>" + ccDataToSave.Phone + "</td></tr>";
        message = message + "<tr><td><strong>Customer Email:</strong> </td><td>" + ccDataToSave.Email + "</td></tr>";
        message = message + "<tr><td><strong>Event Title:</strong> </td><td>" + registrationState.EventTitle + "</td></tr>";
        message = message + "<tr><td><strong>Event Description:</strong> </td><td>" + registrationState.EventDescription + "</td></tr>";
        message = message + "</table>";
        message = message + "</body></html>";
        //Lets send the email
        const sendEmail = fetch(rest.sendmail, {
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': rest.apiKey
            }),
            method: 'POST',
            body: JSON.stringify({
                to: rest.email,
                from: rest.email,
                subject: "New Registration Request",
                message: message
            })
        });
        const emailResponse = await sendEmail;
        const emailResult = await emailResponse.json();
        console.log('📧 Email Result:', emailResult);

        if(registerResult.Status === "Success") {
            console.log('✅ Registration Successful!');
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
            successAlert(true);
        } else {
            console.error('❌ Registration Failed!');
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
            successAlert(false);
        }
        } catch (error) {
            console.error('❌ Registration Error:', error);
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
            successAlert(false);
        }
    };

    React.useImperativeHandle(ref, () => ({
        isValidated: () => {
            return isValidated();
        },
  }));

  return (
    <>
    <div className="App-payment">
        <Card
            number={localCCNumber}
            name={localCCName}
            expiry={localCCExpiry}
            cvc={localCCCvc}
            focused={focused}
            callback={handleCallback}

        />
    </div>
    <Row className="justify-content-center">
        <Col md={6} mdOffset={3}>
            <FormGroup>
                <Label>Credit Card Number <span className="text-danger">*</span></Label>
                {(numberError === null) ? (
                    <FormControl
                        className="valid"
                        id="number"
                        type="tel"
                        name="number"
                        maxLength="19"
                        placeholder="Card Number E.g.: 4917 6123 4567 8901"
                        value={formatCCNumber(localCCNumber)}
                        pattern="[\d ]{13,19}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                ) : (
                    <FormControl
                        className="error"
                        id="number"
                        type="tel"
                        name="number"
                        maxLength="19"
                        placeholder="Card Number E.g.: 4917 6123 4567 8901"
                        value={formatCCNumber(localCCNumber)}
                        pattern="[\d ]{13,19}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                )}
                {numberError}
            </FormGroup>
        </Col>
    </Row>
    <Row className="justify-content-center">
        <Col md={6} mdOffset={3}>
            <FormGroup>
                <Label>Name on Credit Card <span className="text-danger">*</span></Label>
                {(nameError === null) ? (
                    <FormControl
                        className="valid"
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Name on Card"
                        value={localCCName}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                ) : (
                    <FormControl
                        className="error"
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Name on Card"
                        value={localCCName}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                )}
                {nameError}
            </FormGroup>
        </Col>
    </Row>
    <Row className="justify-content-center">
        <Col md={2} mdOffset={3}>
            <FormGroup>
                <Label>Expiration <span className="text-danger">*</span></Label>
                {(expiryError === null) ? (
                    <FormControl
                        className="valid"
                        id="expiry"
                        type="tel"
                        name="expiry"
                        maxLength="5"
                        placeholder="MM/YY"
                        value={localCCExpiry}
                        pattern="\d\d/\d\d"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                ) : (
                    <FormControl
                        className="error"
                        id="expiry"
                        type="tel"
                        name="expiry"
                        maxLength="5"
                        placeholder="MM/YY"
                        value={localCCExpiry}
                        pattern="\d\d/\d\d"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                )}
                {expiryError}
            </FormGroup>
        </Col>
        <Col md={2} >
            <FormGroup>
                <Label>CVC <span className="text-danger">*</span></Label>
                {(cvcError === null) ? (
                    <FormControl
                        className="valid"
                        id="cvc"
                        type="tel"
                        name="cvc"
                        maxLength="4"
                        placeholder="CVC"
                        value={localCCCvc}
                        pattern="\d{3,4}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                ) : (
                    <FormControl
                        className="error"
                        id="cvc"
                        type="tel"
                        name="cvc"
                        maxLength="4"
                        placeholder="CVC"
                        value={localCCCvc}
                        pattern="\d{3,4}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                )}
                {cvcError}
            </FormGroup>
        </Col>
        <Col md={2}>
            <FormGroup>
                <Label>Zip Code <span className="text-danger">*</span></Label>
                {(zipError === null) ? (
                    <FormControl
                        className="valid"
                        id="zip"
                        type="tel"
                        name="zip"
                        maxLength="5"
                        placeholder="ex: 80107"
                        value={localCCZip}
                        pattern="\d{5}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                ) : (
                    <FormControl
                        className="error"
                        id="zip"
                        type="tel"
                        name="zip"
                        maxLength="5"
                        placeholder="ex: 80107"
                        value={localCCZip}
                        pattern="\d{5}"
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={syncToContext}
                    />
                )}
                {zipError}
            </FormGroup>
        </Col>
    </Row>
    <Row className="justify-content-center">
        <Col md={8} mdOffset={3}>
            <hr />
            <h6>All participants in events sponsored by The Deep VBC must sign our online waiver and release form, at least once.  If you have already
                signed our online waiver and and release form, then you can simply click the agree checkbox below and finish your registration.  However,
                if you have never signed our online waiver and release form, please do so by clicking on this link:<br /><br />
                <a href = "https://waiver.smartwaiver.com/w/5f9304eda663f/web/" target = "_blank">Sign The Deep VBC Waiver and Release Online Form</a>.
                <br /><br />Failure to sign our waiver and agree to its terms will result in your registration being cancelled.</h6>
            <hr />
        </Col>
    </Row>
    <Row className="justify-content-center">
        <Col md={7} mdOffset={3}>
            <FormGroup check>
                {(agreeError === null) ? (
                <Label check>
                    <Input
                        type="checkbox"
                        name="agreeCheckbox"
                        className="valid"
                        id="agreeCheckbox"
                        checked={agree}
                        onChange={(e) => {setagree(!agree);}}
                    />{' '}
                    I have reviewed, signed and agree to the The Deep VBC Online Waiver and Release form listed above.
                    <span className="form-check-sign">
                        <span className="check"></span>
                    </span>
                </Label>
                ) : (
                    <Label check>
                        <Input
                            type="checkbox"
                            name="agreeCheckbox"
                            className="error"
                            id="agreeCheckbox"
                            checked={agree}
                            onChange={(e) => {setagree(!agree); }}
                        />{' '}
                        I have reviewed, signed and agree to the The Deep VBC Online Waiver and Release form listed above.
                        <span className="form-check-sign">
                        <span className="check"></span>
                    </span>
                    </Label>
                )}
                <br />
                {agreeError}
            </FormGroup>
        </Col>
    </Row>
    {alert}
    </>
  );
});

export default Step3;
